"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cssStyle = exports.cssBoxShadow = exports.cssBorderRadius = exports.cssBorder = exports.boxShadowDefinition = exports.cssBorderColor = exports.cssColor = exports.cssBorderStyle = exports.cssBorderWidth = exports.cssUnitValue = exports.cssLength = void 0;
var yup = __importStar(require("yup"));
var cssPercentageUnit = __spreadArray([], ['%']);
var cssAbsLengthUnit = __spreadArray([], ['px', 'cm', 'mm', 'q', 'in', 'pt', 'pc']);
var cssRelativeLengthUnit = __spreadArray([], ['em', 'ex', 'ch', 'rem', 'vw', 'vh', 'vmin', 'vmax']);
var cssBorderStyleTypes = __spreadArray([], [
    'none',
    'hidden',
    'dotted',
    'dashed',
    'solid',
    'double',
    'groove',
    'ridge',
    'inset',
    'outset',
]);
exports.cssLength = yup
    .object({
    unit: yup
        .mixed()
        .oneOf(__spreadArray(__spreadArray([], cssAbsLengthUnit), cssRelativeLengthUnit)),
    value: yup.number(),
})
    .noUnknown();
exports.cssUnitValue = yup
    .object({
    unit: yup
        .mixed()
        .oneOf(__spreadArray(__spreadArray(__spreadArray([], cssPercentageUnit), cssAbsLengthUnit), cssRelativeLengthUnit)),
    value: yup.number(),
})
    .noUnknown();
exports.cssBorderWidth = yup
    .object({
    top: exports.cssLength.required(),
    right: exports.cssLength.required(),
    bottom: exports.cssLength.required(),
    left: exports.cssLength.required(),
})
    .noUnknown();
var cssBrStyle = yup.mixed().oneOf(cssBorderStyleTypes);
exports.cssBorderStyle = yup
    .object({
    top: cssBrStyle.required(),
    right: cssBrStyle.required(),
    bottom: cssBrStyle.required(),
    left: cssBrStyle.required(),
})
    .noUnknown();
var cssByte = yup.number().min(0).max(255);
exports.cssColor = yup
    .object({
    red: cssByte.required(),
    green: cssByte.required(),
    blue: cssByte.required(),
    alpha: yup.number().min(0).max(1).required(),
})
    .noUnknown();
exports.cssBorderColor = yup
    .object({
    top: exports.cssColor.required(),
    right: exports.cssColor.required(),
    bottom: exports.cssColor.required(),
    left: exports.cssColor.required(),
})
    .noUnknown();
exports.boxShadowDefinition = yup
    .object({
    inset: yup.boolean(),
    offsetX: exports.cssLength,
    offsetY: exports.cssLength,
    blurRadius: exports.cssLength,
    spreadRadius: exports.cssLength,
    color: exports.cssColor,
})
    .noUnknown();
exports.cssBorder = yup
    .object({
    width: exports.cssBorderWidth.required(),
    style: exports.cssBorderStyle.required(),
    color: exports.cssBorderColor.required(),
})
    .noUnknown();
exports.cssBorderRadius = yup.object({
    topLeft: exports.cssUnitValue,
    topRight: exports.cssUnitValue,
    bottomRight: exports.cssUnitValue,
    bottomLeft: exports.cssUnitValue,
});
exports.cssBoxShadow = yup.array().of(exports.boxShadowDefinition).min(1);
exports.cssStyle = yup.object({
    cssBorder: exports.cssBorder.default(undefined),
    cssBoxShadow: exports.cssBoxShadow.default(undefined),
    cssBorderRadius: exports.cssBorderRadius.default(undefined),
});
//# sourceMappingURL=Css.schema.js.map